import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import { Formulario } from './../interface/fomulario';

export class Email implements Formulario {


    public static matchValues(matchTo: string): (AbstractControl) => ValidationErrors | null {
        return (control: AbstractControl): ValidationErrors | null => {
          return !!control.parent &&
            !!control.parent.value &&
            control.value === control.parent.controls[matchTo].value
            ? null
            : { isMatching: false };
        };
    }

    createFormulario(): any[] {
        const form = [{element: 'email', name: 'email', label: 'Correo electrónico*', validations: [Validators.required, Validators.email]},
        {element: 'email', name: 'email2', label: 'Repetir correo*', notSave: true, validations: [Validators.required, Validators.email,
            Email.matchValues('email')]},
        {element: 'password', name: 'password', label: 'Contraseña*', validations: [Validators.required, Validators.minLength(8)]},
        {element: 'password', name: 'password2', label: 'Repetir contraseña*', notSave: true,
         validations: [Validators.required, Validators.minLength(8),
            Email.matchValues('password')]}
    ];
        return form;
    }
}
